import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { AnyBuildId } from '@portal-core/builds/constants/any-build-id.constant';
import { LatestBuildId } from '@portal-core/builds/constants/latest-build-id.constant';
import { Build } from '@portal-core/builds/models/build.model';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';

@CollectionStateSelectors({
  stateType: BuildsState
})
@State<BuildsState>({
  name: BuildsState.source,
})
@Service({ autoProvided: false })
export class BuildsState extends CollectionStateBase {
  static override source: string = 'Builds';

  static override readonly defaultItems: Partial<Build>[] = [{
    Id: AnyBuildId
  }, {
    Id: LatestBuildId
  }];

  override getDefaultItems(): Partial<Build>[] {
    return BuildsState.defaultItems;
  }

  getSource(): string {
    return BuildsState.source;
  }
}

@Service()
export class BuildsDataService extends CollectionDataServiceBase<Build> {
  protected readonly stateType = BuildsState;
}
